import { render, staticRenderFns } from "./NewEditAlunoPage.vue?vue&type=template&id=1960a853&scoped=true"
import script from "./NewEditAlunoPage.vue?vue&type=script&lang=js"
export * from "./NewEditAlunoPage.vue?vue&type=script&lang=js"
import style0 from "./NewEditAlunoPage.vue?vue&type=style&index=0&id=1960a853&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1960a853",
  null
  
)

export default component.exports